import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const STEPS = [
  {
    title: 'Bienvenido a GranArqui Interno',
    description: 'Esta PWA está diseñada para el trabajo en campo. Instálala para acceso rápido y sin distracciones.',
    emoji: '🏗️',
  },
  {
    title: 'Trabaja sin conexión',
    description: 'Registra avances, sube fotos y envía mensajes aunque no tengas señal. Todo se sincroniza automáticamente.',
    emoji: '📴',
  },
  {
    title: 'Instálala en tu teléfono',
    description: 'Usa el menú de tu navegador → “Añadir a pantalla de inicio”. Se abrirá como app nativa.',
    emoji: '📲',
  },
];

export function OnboardingPage() {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();

  const finish = () => {
    localStorage.setItem('pwa_internal_onboarding_done', '1');
    navigate('/gestion/dashboard', { replace: true });
  };

  const current = STEPS[step];
  const isLast = step === STEPS.length - 1;

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col safe-top safe-bottom">
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-sm w-full text-center text-white">
          <div className="text-7xl mb-6">{current.emoji}</div>
          <h1 className="text-2xl font-bold mb-3">{current.title}</h1>
          <p className="text-white/70 leading-relaxed">{current.description}</p>

          <div className="flex items-center justify-center gap-2 mt-8">
            {STEPS.map((_, i) => (
              <span
                key={i}
                className={`h-2 rounded-full transition-all ${
                  i === step ? 'w-8 bg-primary' : 'w-2 bg-white/30'
                }`}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="px-6 pb-8 space-y-2">
        <button
          onClick={() => (isLast ? finish() : setStep((s) => s + 1))}
          className="w-full py-3 rounded-lg bg-primary text-white font-semibold active:bg-primary-dark"
        >
          {isLast ? 'Comenzar' : 'Siguiente'}
        </button>
        {!isLast && (
          <button
            onClick={() => setStep((s) => s + 1)}
            className="w-full py-2 text-sm text-white/60"
          >
            Omitir
          </button>
        )}
      </div>
    </div>
  );
}